module.exports = __webpack_public_path__ + "img/02.故宫蟠龙槐（杨树田-摄）.4f191479.jpg";